import { Content } from "layouts/Content";
import { TextInput } from "layouts/Form/TextInput";
import { Main } from "layouts/Main";
import { Panel } from "layouts/Panel";
import Sidebar from "../Sidebar";
import { MdHelp } from "react-icons/md";
import { ROButton } from "layouts/RoButton";
import { useEffect, useState, useRef } from "react";
import { deleteLinkedPayer, fetchAllLinkedPayers, linkPayerWithInsurance, updateLinkedPayer } from "./helper";
import { TrizettoPayerList } from "./TrizettoPayersList";
import { LinkedPayerTable } from "./LinkedPayerTable";
import { LinkedInsuracePayerFooter } from "./Footer";
import { useParams } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import { LoadingSpinner } from "lib/loader";
import { RoAlert } from "layouts/RoAlert";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { Button } from "@mui/material";
import { attachState } from "./constants";
import ReactChipInput from "react-chip-input";
import ChipInputWithSeparators from "./keywordChips";
// Import MapFilterToApiKeys helper from constants used in the child
import { MapFilterToApiKeys } from "./Footer/constants";

const Insurances = ({ }) => {
  const paramsConsumedRef = useRef(false);
  const [linkedPayers, setLinkedPayers] = useState([]);
  const [linkedPayersCache, setLinkedPayersCache] = useState([]);
  // LIFT states from child to parent
  const [activeFilter, setActiveFilter] = useState("Insurance Name");
  const [searchInput, setSearchInput] = useState("");

  const [selectedInsurancePayer, setSelectedInsurancePayer] = useState();
  const [selectedInsurancePayerId, setSelectedInsurancePayerId] = useState();
  const [showTrizettoModal, setShowTrizettoModal] = useState(false);
  const [showLinkingModal, setShowLinkingModal] = useState(false);
  const handleOpenLinkingModal = () => setShowLinkingModal(true);
  const handleOpenTrizettoModal = () => setShowTrizettoModal(false);
  const handleCloseTrizettoModal = () => setShowTrizettoModal(false);
  const [showLinkingConfirmation, setShowLinkingConfirmation] = useState(false);
  const [showTicketModal, setShowTicketModal] = useState(false);

  const handleLinkingConfirmation = () => setShowLinkingConfirmation(!showLinkingConfirmation)
  const handleTicketModal = () => setShowTicketModal(!showTicketModal)

  const params = useParams();
  const location = useLocation();
  params.payerName = location?.state?.PrimaryInsurancePlanName;
  const { encounterId, payerName, payerId, encounterType } = useParams();
  const [isNewLinking, setIsNewLinking] = useState(false);
  const [linkPayerVal, setLinkPayerVal] = useState({
    payerName: payerName || "",
    payerId: payerId || "",
    claimsPhoneNumber: "",
    mailingAddress: "",
    appealsMailingAddress: "",
    payerUrl: "",
    appealViaPortal: "",
    appealURL: '',
    firstTimeBilled: "",
    dateOfDenial: "",
    inNetworkStatus: "",
    eraSetup: "",
    keywordsActive: [],
    keywordsViolate: []
  });
  const [isRowChecked, setIsRowChecked] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [showEditConfirmation, setShowEditConfirmation] = useState(false);
  const [selectedTrizettoPayer, setSelectedTrizettoPayer] = useState();


  /** -------------------------------- TRIZETTO PAYER LIST STATE MANAGEMENT ----------------------------------- **/

  
  // const [insurancePayers, setInsurancePayers] = useState([]);
  // const [insurancePayersRecord, setInsurancePayersRecord] = useState([]);
  // // const [selectedTrizettoPayer, setSelectedTrizettoPayer] = useState(selectedInsurancePayer);
  // const [selectedSearchType, setSelectedSearchType] = useState("payerId");
  // const [searchPayerInput, setSearchPayerInput] = useState("");
  // const [showTableLoader, setShowTableLoader] = useState(false);
  // // const [showLinkingConfirmation, setShowLinkingConfirmation] = useState();
  // // const [showTicketModal, setShowTicketModal] = useState(ticketModal);
  // const [showBypassModal, setShowBypassModal] = useState(false);



  /**
    * Adds a new chip to the specified array in the state.
    * @param {'keywordsActive' | 'keywordsViolate'} type The key of the array to modify.
    * @param {string} value The value of the chip to add.
    */
  const addChip = (type, value) => {
    if (value.trim() !== '' && !linkPayerVal[type].includes(value.trim())) {
      setLinkPayerVal(prevState => ({
        ...prevState,
        // Use computed property names to dynamically update the correct array
        [type]: [...prevState[type], value.trim()]
      }));
    }
  };

  /**
   * Removes a chip from the specified array in the state by index.
   * @param {'keywordsActive' | 'keywordsViolate'} type The key of the array to modify.
   * @param {number} index The index of the chip to remove.
   */
  const removeChip = (type, index) => {
    setLinkPayerVal(prevState => {
      const currentChips = [...prevState[type]];
      currentChips.splice(index, 1);
      return {
        ...prevState,
        // Use computed property names to dynamically update the correct array
        [type]: currentChips
      };
    });
  };

  // const handleSelectInsurance = (cell, rowIndex) => {
  //   const [name, id] = cell;
  //   const company = insurancePayers.find((i) => {
  //     if (i.payerName === name.val && i.payerId === id.val) {
  //       return i;
  //     }
  //   });
  //   const payer = {
  //     payerName: name.val,
  //     payerId: id.val,
  //     id: company.id,
  //     state: company.state,
  //   };
  //   setSelectedTrizettoPayer(payer);
  // };

  // Reusable filter function (place it in the parent or a utility file)
  const applyFilter = (filterVal, filterKey, listToFilter) => {
    if (filterVal === "" || !filterVal) {
      return listToFilter;
    }
    const searchFor = MapFilterToApiKeys[filterKey];
    return listToFilter.filter((payer) => {
      if (typeof payer[searchFor] === "string") {
        const uppercaseStr = payer[searchFor].toUpperCase();
        const uppercaseVal = filterVal.toUpperCase();
        return uppercaseStr.includes(uppercaseVal);
      } else {
        return payer[searchFor] === filterVal;
      }
    });
  };

  // const handleSelectInsurancePayer = (e, linkpayer) => {
  //   const isChecked = e.target.checked;
  //   // setSelectedInsurancePayerId(isChecked ? linkpayer.id : undefined);
  //   setSelectedInsurancePayerId(isChecked ? linkpayer.linkedPayerId : undefined);
  //   setSelectedInsurancePayer(isChecked ? linkpayer : undefined);
  //   setIsRowChecked(isChecked ? true : false)
  //   if (isChecked) {
  //     const linkPayerObj = {
  //       payerName: linkpayer.linkedPayer || "",
  //       payerId: linkpayer.linkedPayerId || "",
  //       claimsPhoneNumber: linkpayer.claimPhoneNumber || "",
  //       mailingAddress: linkpayer.mailingAddress || "",
  //       appealsMailingAddress: linkpayer.appealsMailingAddress || "",
  //       payerUrl: linkpayer.payerURL || "",
  //       appealViaPortal: linkpayer.appealViaPortal || "",
  //       appealURL: linkpayer.appealViaPortal == 'yes' ? linkpayer.appealURL : "" || "",
  //       firstTimeBilled: linkpayer.firstTimeBilled || "",
  //       dateOfDenial: linkpayer.dateOfDenial || "",
  //       inNetworkStatus: linkpayer.inNetworkStatus || "",
  //       eraSetup: linkpayer.ERASetup || "",
  //       keywordsActive: linkpayer.keywordsActive || [],
  //       keywordsViolate: linkpayer.keywordsViolate || []
  //     }
  //     setLinkPayerVal(linkPayerObj)
  //   } else {
  //     setLinkPayerVal({
  //       payerName: payerName || "",
  //       payerId: payerId || "",
  //       claimsPhoneNumber: "",
  //       mailingAddress: "",
  //       appealsMailingAddress: "",
  //       payerUrl: "",
  //       appealViaPortal: "",
  //       appealURL: "",
  //       firstTimeBilled: "",
  //       dateOfDenial: "",
  //       inNetworkStatus: "",
  //       eraSetup: "",
  //       keywordsActive: [],
  //       keywordsViolate: []
  //     })
  //   }
  // };

  const handleSelectInsurancePayer = (e, linkpayer) => {
    const isChecked = e.target.checked;

    setSelectedInsurancePayerId(isChecked ? linkpayer.linkedPayerId : undefined);
    setSelectedInsurancePayer(isChecked ? linkpayer : undefined);
    setIsRowChecked(isChecked);

    if (!isChecked) {
      // If user UNCHECKS, and the list is currently filtered (length is 1),
      // restore the full list from cache.
      if (linkedPayers.length === 1) {
        setLinkedPayers(linkedPayersCache);
      }

      setLinkPayerVal({
        payerName: "",
        payerId: "",
        claimsPhoneNumber: "",
        mailingAddress: "",
        appealsMailingAddress: "",
        payerUrl: "",
        appealViaPortal: "",
        appealURL: "",
        firstTimeBilled: "",
        dateOfDenial: "",
        inNetworkStatus: "",
        eraSetup: "",
        keywordsActive: [],
        keywordsViolate: []
      });
    } else {
      // Regular selection logic (don't filter the list here if selecting manually)
      const linkPayerObj = {
        payerName: linkpayer.linkedPayer || "",
        payerId: linkpayer.linkedPayerId || "",
        claimsPhoneNumber: linkpayer.claimPhoneNumber || "",
        mailingAddress: linkpayer.mailingAddress || "",
        appealsMailingAddress: linkpayer.appealsMailingAddress || "",
        payerUrl: linkpayer.payerURL || "",
        appealViaPortal: linkpayer.appealViaPortal || "",
        appealURL: linkpayer.appealViaPortal == 'yes' ? linkpayer.appealURL : "" || "",
        firstTimeBilled: linkpayer.firstTimeBilled || "",
        dateOfDenial: linkpayer.dateOfDenial || "",
        inNetworkStatus: linkpayer.inNetworkStatus || "",
        eraSetup: linkpayer.ERASetup || "",
        keywordsActive: linkpayer.keywordsActive || [],
        keywordsViolate: linkpayer.keywordsViolate || []
      };
      setLinkPayerVal(linkPayerObj);
    }
  };


  const handleAfterUpdateLinkedPayer = (linkedPayer) => {
    // const indexOfLinkedPayer = linkedPayers.findIndex(
    //   (payer) => payer.id === linkedPayer.id
    // );
    // if (indexOfLinkedPayer !== -1) {
    //   linkedPayers[indexOfLinkedPayer] = linkedPayer;
    //   setLinkedPayers(linkedPayers);
    //   setLinkedPayersCache(linkedPayers);
    // }
    // Step 1: Update the master list (cache)
    const updatedCache = linkedPayersCache.map(payer =>
      payer.id === linkedPayer.id ? linkedPayer : payer
    );

    // Step 2: Set the updated master list state
    setLinkedPayersCache(updatedCache);

    // Step 3: Re-apply the filter to the *new* master list using the *current* filter criteria
    const reFilteredList = applyFilter(searchInput, activeFilter, updatedCache);

    // Step 4: Update the displayed list
    setLinkedPayers(reFilteredList);
  };

  const handleAfterDeleteLinkedPayer = (linkedPayer) => {
    // console.log(linkedPayer)
    // const listOfLinkedPayer = linkedPayers.filter(
    //   (payer) => payer.linkedPayerId !== linkedPayer.id
    // );
    // setLinkedPayers(listOfLinkedPayer);
    // setLinkedPayersCache(listOfLinkedPayer);
    fetchLinkedPayers();
  };

  const handleDeletePayer = async () => {
    const { linkedPayerId } = selectedInsurancePayer;
    if (!linkedPayerId) return;
    LoadingSpinner.show();
    const res = await deleteLinkedPayer(linkedPayerId);
    if (res) {
      NotificationManager.success("Deleted successfully.");
      handleAfterDeleteLinkedPayer(selectedInsurancePayer);
      setSelectedInsurancePayer(undefined);
      setShowDeleteConfirmation(false);
      setIsRowChecked(false)
      setLinkPayerVal({
        payerName: payerName || "",
        payerId: payerId || "",
        claimsPhoneNumber: "",
        mailingAddress: "",
        appealsMailingAddress: "",
        payerUrl: "",
        appealViaPortal: "",
        appealURL: "",
        firstTimeBilled: "",
        dateOfDenial: "",
        inNetworkStatus: "",
        eraSetup: "",
        keywordsActive: [],
        keywordsViolate: []
      })
    }
    LoadingSpinner.hide();
  };

  const isValid = () => {
    const requiredFields = [
      { key: 'payerId', name: 'Payer ID' },
      { key: 'payerName', name: 'Payer Name' },
      { key: 'claimsPhoneNumber', name: 'Claims Phone Number' },
      { key: 'mailingAddress', name: 'Claims Mailing Address' },
      // { key: 'appealsMailingAddress', name: 'Appeals Mailing Address' },
      // { key: 'payerUrl', name: 'EOB URL' },
      { key: 'appealViaPortal', name: 'Appeal Via Portal' },
      { key: 'firstTimeBilled', name: 'First Time Billed' },
      { key: 'dateOfDenial', name: 'Date of Denial' },
      { key: 'inNetworkStatus', name: 'In Network Status' },
      { key: 'eraSetup', name: 'ERA Setup' }
    ];

    // 2. Dynamic validation loop
    for (const field of requiredFields) {
      if (!linkPayerVal[field.key]) {
        NotificationManager.error(`${field.name} is required.`, '', 2000);
        return false; // Stop at the first error found
      }
    }

    // 3. Conditional validation for Appeal URL
    if (linkPayerVal.appealViaPortal === 'yes' && !linkPayerVal.appealURL) {
      NotificationManager.error("Appeal URL is required", '', 2000);
      return false;
    }
    return true;
  }

  const handleSaveClick = async () => {
    const { payerId, payerName, claimsPhoneNumber, mailingAddress, appealsMailingAddress, payerUrl, appealViaPortal, appealURL,
      firstTimeBilled, dateOfDenial, inNetworkStatus, eraSetup, keywordsActive, keywordsViolate } = linkPayerVal;
    // await updateLinkState(linkPayerVal)
    // if (!payerId || !payerName) {
    //   NotificationManager.error("Invalid form values");
    //   return;
    // }
    const res = await updateLinkedPayer({
      ...selectedInsurancePayer,
      linkedPayer: payerName,
      linkedPayerId: payerId,
      claimPhoneNumber: claimsPhoneNumber,
      mailingAddress: mailingAddress,
      appealsMailingAddress: appealsMailingAddress,
      appealViaPortal: appealViaPortal,
      appealURL: appealViaPortal == 'yes' ? appealURL : "",
      payerURL: payerUrl,
      firstTimeBilled: firstTimeBilled,
      dateOfDenial: dateOfDenial,
      inNetworkStatus: inNetworkStatus,
      ERASetup: eraSetup,
      keywordsActive: keywordsActive,
      keywordsViolate: keywordsViolate
    });
    if (res) {
      handleAfterUpdateLinkedPayer({
        ...selectedInsurancePayer,
        linkedPayer: payerName,
        linkedPayerId: payerId,
        claimPhoneNumber: claimsPhoneNumber,
        mailingAddress: mailingAddress,
        appealsMailingAddress: appealsMailingAddress,
        appealViaPortal: appealViaPortal,
        appealURL: appealViaPortal == 'yes' ? appealURL : "",
        payerURL: payerUrl,
        firstTimeBilled: firstTimeBilled,
        dateOfDenial: dateOfDenial,
        inNetworkStatus: inNetworkStatus,
        ERASetup: eraSetup,
        keywordsActive: keywordsActive,
        keywordsViolate: keywordsViolate
      });
      NotificationManager.success("Updated successfully.");
      setLinkPayerVal({
        payerName: "",
        payerId: "",
        claimsPhoneNumber: "",
        mailingAddress: "",
        appealsMailingAddress: "",
        payerUrl: "",
        appealViaPortal: "",
        appealURL: "",
        firstTimeBilled: "",
        dateOfDenial: "",
        inNetworkStatus: "",
        eraSetup: "",
        keywordsActive: [],
        keywordsViolate: []
      })
      setShowEditConfirmation(false);
      fetchLinkedPayers();
      setIsRowChecked(false)
    }
  };

  const handleAfterRelinking = (payer, trizettoInsuranceCompany) => {
    if (!payer || !trizettoInsuranceCompany) {
      console.error("Debug on line number 54 - insurances/index.jsx");
      return;
    }

    const { id } = payer;
    const indexOfSelectedPayer = linkedPayers.findIndex(
      (payer) => payer.id === id
    );

    if (indexOfSelectedPayer !== -1) {
      linkedPayers[indexOfSelectedPayer].payerId =
        trizettoInsuranceCompany.payerId;
      linkedPayers[indexOfSelectedPayer].payerName =
        trizettoInsuranceCompany.payerName;
      linkedPayers[indexOfSelectedPayer].state = trizettoInsuranceCompany.state;

      setLinkedPayers([...linkedPayers]);
      setLinkedPayersCache([...linkedPayers]);
      setSelectedInsurancePayer({ ...linkedPayers[indexOfSelectedPayer] });
    }
  };

  const handleLinkClick = async () => {
    const { payerId, payerName, claimsPhoneNumber, mailingAddress, appealsMailingAddress, payerUrl,
      appealViaPortal, appealURL, firstTimeBilled, dateOfDenial, inNetworkStatus, eraSetup, keywordsActive, keywordsViolate } = linkPayerVal;
    // const isValidated = !Object.values(linkPayerVal).includes("");
    // if (!isValidated) {
    //   NotificationManager.error("Payer name and payer id is required.");
    //   return;
    // }

    // if (!payerId || !payerName || !claimsPhoneNumber || !mailingAddress || !appealsMailingAddress || !payerUrl ||
    //   !appealViaPortal || (appealViaPortal == 'yes' && !appealURL) || !firstTimeBilled || !dateOfDenial || !inNetworkStatus || !eraSetup) {
    //   NotificationManager.error("Please enter the values.");
    //   return;
    // }
    const requiredFields = [
      { key: 'payerId', name: 'Payer ID' },
      { key: 'payerName', name: 'Payer Name' },
      { key: 'claimsPhoneNumber', name: 'Claims Phone Number' },
      { key: 'mailingAddress', name: 'Claims Mailing Address' },
      // { key: 'appealsMailingAddress', name: 'Appeals Mailing Address' },
      // { key: 'payerUrl', name: 'EOB URL' },
      { key: 'appealViaPortal', name: 'Appeal Via Portal' },
      { key: 'firstTimeBilled', name: 'First Time Billed' },
      { key: 'dateOfDenial', name: 'Date of Denial' },
      { key: 'inNetworkStatus', name: 'In Network Status' },
      { key: 'eraSetup', name: 'ERA Setup' }
    ];

    // 2. Dynamic validation loop
    for (const field of requiredFields) {
      if (!linkPayerVal[field.key]) {
        NotificationManager.error(`${field.name} is required.`, '', 2000);
        return; // Stop at the first error found
      }
    }

    // 3. Conditional validation for Appeal URL
    if (linkPayerVal.appealViaPortal === 'yes' && !linkPayerVal.appealURL) {
      NotificationManager.error("Appeal URL is required", '', 2000);
      return;
    }

    const isAlreadyLinked = (linkedPayers || []).find((payer) => {
      if (payer.linkedPayerId === payerId) {
        return payer;
      }
    });

    if (isAlreadyLinked) {
      setSelectedInsurancePayerId(isAlreadyLinked.id);
      setSelectedInsurancePayer({ ...isAlreadyLinked });
      NotificationManager.error(
        `${payerName} is already linked. You can relink it by selecting it from the table below.`
      );
      return;
    }

    await setSelectedInsurancePayer({
      ...selectedInsurancePayer,
      linkedPayer: payerName,
      linkedPayerId: payerId,
      claimPhoneNumber: claimsPhoneNumber,
      mailingAddress: mailingAddress,
      appealsMailingAddress: appealsMailingAddress,
      appealViaPortal: appealViaPortal,
      appealURL: appealViaPortal == 'yes' ? appealURL : "",
      payerURL: payerUrl,
      firstTimeBilled: firstTimeBilled,
      dateOfDenial: dateOfDenial,
      inNetworkStatus: inNetworkStatus,
      ERASetup: eraSetup,
      keywordsActive: keywordsActive,
      keywordsViolate: keywordsViolate
    });
    if (!params) await setSelectedInsurancePayerId();
    setIsNewLinking(true);
    await handleOpenLinkingModal();
  };

  const fetchLinkedPayers = async () => {
    LoadingSpinner.show();
    // const linkedPayersList = await fetchAllLinkedPayers();
    // await setSelectedInsurancePayer(undefined)
    // await setSelectedInsurancePayerId(undefined)
    // await setLinkedPayers(linkedPayersList);
    // await setLinkedPayersCache(linkedPayersList);

    // 1. (Optional but safer) Capture the current filter state
    const currentSearchInput = searchInput;
    const currentActiveFilter = activeFilter;

    // 2. Fetch the new, clean list from the API
    const linkedPayersList = await fetchAllLinkedPayers();

    // 3. Reset selected items
    await setSelectedInsurancePayer(undefined);
    await setSelectedInsurancePayerId(undefined);

    // 4. Update the master cache with the fresh data
    await setLinkedPayersCache(linkedPayersList);

    // 5. Re-apply the previously saved filter criteria to the *new* master list
    const reFilteredList = applyFilter(
      currentSearchInput,
      currentActiveFilter,
      linkedPayersList // Use the freshly fetched list immediately
    );

    // 6. Update the displayed list with the re-filtered results
    await setLinkedPayers(reFilteredList);
    LoadingSpinner.hide();
  };

  const handleNewLinking = async (buttonType) => {
    if (!selectedInsurancePayer) {
      NotificationManager.error("No payer is selected");
      return;
    }
    LoadingSpinner.show();
    const res = await linkPayerWithInsurance(selectedInsurancePayer.id, {
      linkedPayerId: selectedInsurancePayer.linkedPayerId,
      linkedPayer: selectedInsurancePayer.linkedPayer,
      insuranceType: encounterType,
      encounterId: encounterId,
      payerName: selectedInsurancePayer && selectedInsurancePayer?.payerName ?
        selectedInsurancePayer?.payerName.trim() +
        " " +
        attachState(selectedInsurancePayer?.state && selectedInsurancePayer?.state) : '',
      buttonType: buttonType,
      claimPhoneNumber: linkPayerVal.claimsPhoneNumber,
      mailingAddress: linkPayerVal.mailingAddress,
      appealsMailingAddress: linkPayerVal.appealsMailingAddress,
      appealViaPortal: linkPayerVal.appealViaPortal,
      appealURL: linkPayerVal.appealViaPortal == 'yes' ? linkPayerVal.appealURL : "",
      payerURL: linkPayerVal.payerUrl,
      firstTimeBilled: linkPayerVal.firstTimeBilled,
      dateOfDenial: linkPayerVal.dateOfDenial,
      inNetworkStatus: linkPayerVal.inNetworkStatus,
      ERASetup: linkPayerVal.eraSetup,
      keywordsActive: linkPayerVal.keywordsActive,
      keywordsViolate: linkPayerVal.keywordsViolate
    });
    if (res) {
      setLinkPayerVal({
        payerName: "",
        payerId: "",
        claimsPhoneNumber: "",
        mailingAddress: "",
        appealsMailingAddress: "",
        payerUrl: "",
        appealViaPortal: "",
        appealURL: "",
        firstTimeBilled: "",
        dateOfDenial: "",
        inNetworkStatus: "",
        eraSetup: "",
        keywordsActive: [],
        keywordsViolate: []
      });
      fetchLinkedPayers();
      NotificationManager.success("Linked successfully.");
      setShowLinkingModal(false);
    }
    LoadingSpinner.hide();
  };

  useEffect(() => {
    fetchLinkedPayers();
  }, []);

  // useEffect(() => {
  //   if (params && params.payerId && params.payerName) {
  //     console.log(params)
  //     const id = (linkedPayers || []).find(
  //       (payer) => payer.linkedPayerId === params.payerId
  //     )?.linkedPayerId;
  //     // )?.id;
  //     console.log(id, linkedPayers)
  //     if (id) {
  //       const linkedPayerByQuery = linkedPayers.find(
  //         (payer) => payer.linkedPayerId === params.payerId
  //       );
  //       console.log(linkedPayerByQuery)
  //       setSelectedInsurancePayerId(id);
  //       setSelectedInsurancePayer({
  //         id,
  //         linkedPayerId: id,
  //         linkedPayer: params.payerName,
  //         payerName: linkedPayerByQuery.payerName,
  //         payerId: linkedPayerByQuery.payerId,
  //       });
  //       setIsNewLinking(false);
  //       setLinkPayerVal({
  //         payerName: linkedPayerByQuery.linkedPayer,
  //         payerId: linkedPayerByQuery.linkedPayerId,
  //         claimsPhoneNumber: linkedPayerByQuery.claimPhoneNumber,
  //         mailingAddress: linkedPayerByQuery.mailingAddress,
  //         appealsMailingAddress: linkedPayerByQuery.appealsMailingAddress,
  //         payerUrl: linkedPayerByQuery.payerURL,
  //         appealViaPortal: linkedPayerByQuery.appealViaPortal,
  //         appealURL: linkedPayerByQuery.appealURL,
  //         firstTimeBilled: linkedPayerByQuery.firstTimeBilled,
  //         dateOfDenial: linkedPayerByQuery.dateOfDenial,
  //         inNetworkStatus: linkedPayerByQuery.inNetworkStatus,
  //         eraSetup: linkedPayerByQuery.ERASetup,
  //         keywordsActive: linkedPayerByQuery.keywordsActive,
  //         keywordsViolate: linkedPayerByQuery.keywordsViolate
  //       });
  //     } else {
  //       setLinkPayerVal({
  //         payerName: "",
  //         payerId: "",
  //         claimsPhoneNumber: "",
  //         mailingAddress: "",
  //         appealsMailingAddress: "",
  //         payerUrl: "",
  //         appealViaPortal: "",
  //         appealURL: "",
  //         firstTimeBilled: "",
  //         dateOfDenial: "",
  //         inNetworkStatus: "",
  //         eraSetup: "",
  //         keywordsActive: "",
  //         keywordsViolate: ""
  //       });
  //       setIsNewLinking(true);
  //     }
  //   }
  // }, [params, linkedPayers]);


  // Keep the Ref at the top


  useEffect(() => {
    const hasParams = params?.payerId && params?.payerName && !paramsConsumedRef.current;
    const hasCache = linkedPayersCache?.length > 0;

    // CASE 1 & 2: Initial Match from Rule Processor
    if (hasParams && hasCache) {
      const matchedPayer = linkedPayersCache.find(
        (payer) => payer.linkedPayerId === params.payerId
      );

      if (matchedPayer) {
        setSelectedInsurancePayerId(matchedPayer.linkedPayerId);
        setSelectedInsurancePayer(matchedPayer);
        setLinkedPayers([matchedPayer]);
        setIsNewLinking(false);

        setLinkPayerVal({
          payerName: matchedPayer.linkedPayer,
          payerId: matchedPayer.linkedPayerId, // Set correctly here
          claimsPhoneNumber: matchedPayer.claimPhoneNumber,
          mailingAddress: matchedPayer.mailingAddress,
          appealsMailingAddress: matchedPayer.appealsMailingAddress,
          payerUrl: matchedPayer.payerURL,
          appealViaPortal: matchedPayer.appealViaPortal,
          appealURL: matchedPayer.appealURL,
          firstTimeBilled: matchedPayer.firstTimeBilled,
          dateOfDenial: matchedPayer.dateOfDenial,
          inNetworkStatus: matchedPayer.inNetworkStatus,
          eraSetup: matchedPayer.ERASetup,
          keywordsActive: matchedPayer.keywordsActive,
          keywordsViolate: matchedPayer.keywordsViolate
        });

        window.history.replaceState(null, '', window.location.pathname);
        paramsConsumedRef.current = true;
        return;
      }
    }

    // CASE 3: FALLBACK (Refresh OR Practice Change)
    // If we reach this point and we have cache, we must reset everything
    // because either params are gone (refresh) or they were already used (practice change)
    if (hasCache) {
      setLinkPayerVal({
        payerName: "",
        payerId: "", // FORCE CLEAR: This ensures "24" or any ID is wiped
        claimsPhoneNumber: "",
        mailingAddress: "",
        appealsMailingAddress: "",
        payerUrl: "",
        appealViaPortal: "",
        appealURL: "",
        firstTimeBilled: "",
        dateOfDenial: "",
        inNetworkStatus: "",
        eraSetup: "",
        keywordsActive: [],
        keywordsViolate: []
      });
      setIsNewLinking(true);
      setSelectedInsurancePayerId(undefined);
      setSelectedInsurancePayer(undefined);
      setLinkedPayers(linkedPayersCache);
    }
  }, [params, linkedPayersCache]);



  // useEffect(() => {
  //   // Check if we have the necessary data and params
  //   const hasParams = params?.payerId && params?.payerName;
  //   const hasCache = linkedPayersCache?.length > 0;

  //   if (hasParams && hasCache) {
  //     const matchedPayer = linkedPayersCache.find(
  //       (payer) => payer.linkedPayerId === params.payerId
  //     );

  //     if (matchedPayer) {
  //       // 1. Pre-select and filter the UI
  //       setSelectedInsurancePayerId(matchedPayer.linkedPayerId);
  //       setSelectedInsurancePayer(matchedPayer);
  //       setLinkedPayers([matchedPayer]);
  //       setIsNewLinking(false);

  //       // 2. Map values to form
  //       setLinkPayerVal({
  //         payerName: matchedPayer.linkedPayer,
  //         payerId: matchedPayer.linkedPayerId,
  //         claimsPhoneNumber: matchedPayer.claimPhoneNumber,
  //         mailingAddress: matchedPayer.mailingAddress,
  //         appealsMailingAddress: matchedPayer.appealsMailingAddress,
  //         payerUrl: matchedPayer.payerURL,
  //         appealViaPortal: matchedPayer.appealViaPortal,
  //         appealURL: matchedPayer.appealURL,
  //         firstTimeBilled: matchedPayer.firstTimeBilled,
  //         dateOfDenial: matchedPayer.dateOfDenial,
  //         inNetworkStatus: matchedPayer.inNetworkStatus,
  //         eraSetup: matchedPayer.ERASetup,
  //         keywordsActive: matchedPayer.keywordsActive,
  //         keywordsViolate: matchedPayer.keywordsViolate
  //       });

  //       // 3. Clean the URL so refresh results in an empty state
  //       window.history.replaceState(null, '', window.location.pathname);
  //       return; // Exit early if we found and handled a match
  //     }
  //   }

  //   // FALLBACK/REFRESH LOGIC:
  //   // If params are missing (e.g. after refresh) or no match found
  //   if (!hasParams && hasCache) {
  //     setLinkPayerVal({
  //       payerName: "",
  //       payerId: "", // This will clear the "24" from your image on refresh
  //       claimsPhoneNumber: "",
  //       mailingAddress: "",
  //       appealsMailingAddress: "",
  //       payerUrl: "",
  //       appealViaPortal: "",
  //       appealURL: "",
  //       firstTimeBilled: "",
  //       dateOfDenial: "",
  //       inNetworkStatus: "",
  //       eraSetup: "",
  //       keywordsActive: [],
  //       keywordsViolate: []
  //     });
  //     setIsNewLinking(true);
  //     setSelectedInsurancePayerId(undefined);
  //     setSelectedInsurancePayer(undefined);

  //     // Restore the full list to the UI
  //     setLinkedPayers(linkedPayersCache);
  //   }
  // }, [params, linkedPayersCache]);




  const renderFooter = () => (
    <LinkedInsuracePayerFooter
      setLinkedPayers={setLinkedPayers}
      linkedPayers={linkedPayersCache}
      activeFilter={activeFilter}
      setActiveFilter={setActiveFilter}
      searchInput={searchInput}
      setSearchInput={setSearchInput}
    />
  );

  // const renderPanelHeader = () => (
  //   <Box>
  //     <div className="row text-left">
  //       <div className="col-md-7">
  //         <TextInput
  //           label="Payer Name:"
  //           onChange={(e) => {
  //             setLinkPayerVal({
  //               ...linkPayerVal,
  //               payerName: e.target.value || "",
  //             });
  //           }}
  //           value={linkPayerVal.payerName}
  //           className="w-100"
  //         />
  //       </div>
  //       <div className="col-md-4">
  //         <TextInput
  //           type="text"
  //           label="Payer ID:"
  //           value={linkPayerVal.payerId}
  //           className="w-100"
  //           onChange={(e) => {
  //             setLinkPayerVal({
  //               ...linkPayerVal,
  //               payerId: e.target.value || "",
  //             });
  //           }}
  //         />
  //       </div>
  //       <div
  //         className="col mt-3 pr-0 pl-0 text-left "
  //         style={{ paddingLeft: "0px", paddingRight: "0px" }}
  //       >
  //         <MdHelp
  //           style={{
  //             fontSize: "35px",
  //             color: "#D8D8D8",
  //             marginRight: "1rem",
  //             marginLeft: "-5px",
  //           }}
  //         />
  //         <ROButton onClick={handleLinkClick} className="mt-2 mt-xxl-0 me-2 me-xxl-0">link</ROButton>
  //       </div>
  //     </div>
  //   </Box>
  // );

  const renderPanelHeader = () => (
    <div className="p-main-cont">
      <div className="p-cont-area">
        <Panel
          heading={"payer details".toUpperCase()}
          className={'paydiv-container'}
          // bodyStyle={{ padding: "10px 5px 10px 5px", height: "calc(100vh - 233px)", overflow: "auto" }}        
          bodyStyle={{ padding: "0px" }}
          headStyle={{ height: "55px" }}>
          <div style={{ padding: "10px 5px 10px 5px", height: "calc(100vh - 283px)", overflow: "auto" }}>
            <div className="payDiv" style={{ padding: "10px" }}>
              <div className="payerdetail-form">
                <TextInput
                  label="Payer Name:"
                  onChange={(e) => {
                    setLinkPayerVal({
                      ...linkPayerVal,
                      payerName: e.target.value || "",
                    });
                  }}
                  value={linkPayerVal.payerName}
                  className="w-100"
                />
                <div className="d-flex gap-3 align-items-end help-payer" >
                  <div className="w-100">
                    <TextInput
                      type="text"
                      label="Payer ID:"
                      value={linkPayerVal.payerId}
                      className=""
                      onChange={(e) => {
                        setLinkPayerVal({
                          ...linkPayerVal,
                          payerId: e.target.value || "",
                        });
                      }}
                    />
                  </div>
                  <MdHelp
                    style={{
                      fontSize: "32px",
                      color: "#D8D8D8",
                    }}
                  />
                </div>
                <TextInput
                  type="text"
                  label="Claims Phone Number:"
                  value={linkPayerVal.claimsPhoneNumber}
                  className="w-100"
                  onChange={(e) => {
                    setLinkPayerVal({
                      ...linkPayerVal,
                      claimsPhoneNumber: e.target.value || "",
                    });

                  }}
                />
                <TextInput
                  type="text"
                  label="Claims Mailing Address:"
                  value={linkPayerVal.mailingAddress}
                  className="w-100"
                  onChange={(e) => {
                    setLinkPayerVal({
                      ...linkPayerVal,
                      mailingAddress: e.target.value || "",
                    });
                  }}
                />
                <TextInput
                  type="text"
                  label="Appeals Mailing Address:"
                  value={linkPayerVal.appealsMailingAddress}
                  className="w-100"
                  onChange={(e) => {
                    setLinkPayerVal({
                      ...linkPayerVal,
                      appealsMailingAddress: e.target.value || "",
                    });
                  }}
                />
                <TextInput
                  type="text"
                  label="Obtain EOB URL:"
                  value={linkPayerVal.payerUrl}
                  className="w-100"
                  onChange={(e) => {
                    setLinkPayerVal({
                      ...linkPayerVal,
                      payerUrl: e.target.value || "",
                    });
                  }}
                />
                <label htmlFor="appeal" className="textInputLabel font-face-futura">Able to Appeal via Portal:</label>
                <select className="w-100 denialSelect2"
                  value={linkPayerVal.appealViaPortal}
                  onChange={(e) => {
                    setLinkPayerVal({
                      ...linkPayerVal,
                      appealViaPortal: e.target.value || "",
                    });
                  }}>
                  <option value="">Select</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
                {linkPayerVal.appealViaPortal == 'yes' && <TextInput
                  type="text"
                  label="Appeal Online URL:"
                  value={linkPayerVal.appealURL}
                  className="w-100"
                  onChange={(e) => {
                    setLinkPayerVal({
                      ...linkPayerVal,
                      appealURL: e.target.value || "",
                    });
                  }}
                />}

                <TextInput
                  type="text"
                  label="Timely Filing Limit in Days (First time billed):"
                  value={linkPayerVal.firstTimeBilled}
                  className="w-100"
                  onChange={(e) => {
                    setLinkPayerVal({
                      ...linkPayerVal,
                      firstTimeBilled: e.target.value || "",
                    });
                  }}
                />
                <TextInput
                  type="text"
                  label="Timely Filing Limit in Days (Date of Denial):"
                  value={linkPayerVal.dateOfDenial}
                  className="w-100"
                  onChange={(e) => {
                    setLinkPayerVal({
                      ...linkPayerVal,
                      dateOfDenial: e.target.value || "",
                    });
                  }}
                />

                <label htmlFor="appeal" className="textInputLabel font-face-futura">In-Network Status:</label>
                <select className="w-100 denialSelect2 font-face-futura"
                  value={linkPayerVal.inNetworkStatus}
                  onChange={(e) => {
                    setLinkPayerVal({
                      ...linkPayerVal,
                      inNetworkStatus: e.target.value || "",
                    });
                  }}>
                  <option value="">Select</option>
                  <option value="inNetwork">In-Network</option>
                  <option value="outOfNetwork">Out-of-Network</option>
                  <option value="notRequired">Not Required</option>
                  <option value="unsure">Unsure</option>
                </select>

                <label htmlFor="appeal" className="textInputLabel font-face-futura">ERA Set Up:</label>
                <select className="w-100 denialSelect2 font-face-futura"
                  value={linkPayerVal.eraSetup}
                  onChange={(e) => {
                    setLinkPayerVal({
                      ...linkPayerVal,
                      eraSetup: e.target.value || "",
                    });
                  }}>
                  <option value="">Select</option>
                  <option value="enrolled">Enrolled</option>
                  <option value="notYet">Not Yet Set Up</option>
                  <option value="inProgress">In Progress</option>
                  <option value="reEnroll">Need to Re-Enroll</option>
                  <option value="unable">Unable to Enroll</option>
                </select>
              </div>
              {/* <div className="mt-5 botDivider"></div> */}
              <div className="mb-2 payerdetail-check">
                {/* <TextInput
                type="text"
                label="Keyword Input for Insurance Eligibility Check:"
                className="w-100"
              />
              <TextInput
                type="text"
                label="Enter Keywords to Violate Insurance Eligibility:"
                className="w-100"
              /> */}
                <span className="font-face-futura" style={{ fontSize: 14, display: 'flex', alignItems: 'center' }}><b>Keyword(s) for Active Insurance Eligibility:</b></span>
                {/* <ReactChipInput
                classes={"chip-green"}
                chips={linkPayerVal.keywordsActive}
                onSubmit={value => addChip('keywordsActive', value)}
                onRemove={index => removeChip('keywordsActive', index)}
              /> */}
                <ChipInputWithSeparators
                  classes={"chip-green"}
                  chips={linkPayerVal.keywordsActive}
                  onAdd={value => addChip('keywordsActive', value)}
                  onRemove={index => removeChip('keywordsActive', index)}
                  separator={"or"}
                />
                <span className="mt-2 font-face-futura" style={{ fontSize: 14, display: 'flex', alignItems: 'center' }}><b>Keyword(s) to Violate Insurance Eligibility:</b></span>
                {/* <ReactChipInput
                classes={"chip-green"}
                chips={linkPayerVal.keywordsViolate}
                onSubmit={value => addChip('keywordsViolate', value)}
                onRemove={index => removeChip('keywordsViolate', index)}
              /> */}
                <ChipInputWithSeparators
                  classes={"chip-green"}
                  chips={linkPayerVal.keywordsViolate}
                  onAdd={value => addChip('keywordsViolate', value)}
                  onRemove={index => removeChip('keywordsViolate', index)}
                  separator={"and"}
                />
              </div>
            </div>
          </div>
          <div className="d-flex paydiv-btn p-3 py-2 bg-transparent">
            {showTrizettoModal ?
              <>
                <Button variant="contained"
                  className="never-btn mx-1"
                  onClick={() => setShowTrizettoModal(false)}
                  fontSize={20}
                >
                  <span className="font-face-futura">NEVERMIND</span>
                </Button>
                <Button variant="contained"
                  fontSize={20}
                  className="link-btn mx-1"
                  onClick={() => {
                    if (selectedInsurancePayer?.payerId === 'ELCMS') {
                      setShowTicketModal(true);
                    } else {
                      setShowLinkingConfirmation(true);
                    }
                  }}
                >
                  <span className="font-face-futura">LINK</span>
                </Button>
              </> : isRowChecked ?
                <div className="d-flex align-items-center justify-content-between w-100">
                  <ROButton
                    disabled={!selectedInsurancePayerId}
                    type="info"
                    className="mx-1"
                    onClick={() => setShowDeleteConfirmation(true)}
                  >
                    Delete
                  </ROButton>
                  <ROButton
                    disabled={!selectedInsurancePayerId}
                    type="primary"
                    className="mx-1"
                    onClick={async () => {
                      if (isValid()) {
                        setShowLinkingConfirmation(false)
                        await setIsNewLinking(false);
                        setShowTrizettoModal(true);
                      }
                    }}
                  >
                    Relink
                  </ROButton>
                  <ROButton
                    disabled={!selectedInsurancePayerId}
                    type="info-light"
                    className="mx-1"
                    onClick={() => {
                      if (isValid()) {
                        setShowEditConfirmation(true)
                      }
                    }}
                  >
                    Save
                  </ROButton>
                </div> :
                <Button variant="contained" onClick={handleLinkClick} className="payer-btn">
                  <span className="font-face-futura">ADD PAYER</span>
                </Button>
            }
            {/* <ROButton onClick={handleLinkClick} className="mt-xxl-0 me-2 me-xxl-0">link</ROButton> */}
          </div>
        </Panel>
      </div>
    </div>
  );

  // const renderTrizettoPayerListModal = () => (
  //   <ROModal
  //     show={showTrizettoModal}
  //     handleClose={handleCloseTrizettoModal}
  //     title="Trizetto Payer List"
  //     style={{ top: "42%" }}
  //   >
  //     <TrizettoPayerList
  //       handleClose={handleCloseTrizettoModal}
  //       selectedInsurancePayer={selectedInsurancePayer}
  //       handleAfterRelinking={handleAfterRelinking}
  //       isNewLinking={isNewLinking}
  //       encounter={{ encounterId, encounterType }}
  //       refreshLinkedPayers={() => {
  //         setLinkPayerVal({
  //           payerName: "",
  //           payerId: "",
  //         });
  //         fetchLinkedPayers();
  //       }}
  //     />
  //   </ROModal>
  // );

  let practiceData = JSON.parse(sessionStorage.getItem("practice"));

  const renderLinkingModal = () => (
    <RoAlert
      show={showLinkingModal}
      showLinking={showLinkingModal}
      handleClose={() => handleNewLinking("add only")}
      handleSubmit={() => {
        setShowTrizettoModal(true)
        setShowLinkingModal(false)
      }}
      // title="you are linking this payer"
      title="want to link payer?"
      type="info"
      content={
        <>
          <div className="alert-footer-text text-center mt-5 mb-4">
            Do you want to link this insurance to the practice:<br />
            <span style={{ color: '#0E0E2C' }}>{practiceData?.practiceName}</span><br />
          </div>
          <div className="alert-footer-text text-center">This will enable the payer to check eligibility</div>
        </>
      }
    />
  );

  const handleChangePractice = (practice) => {
    // 1. Clear existing selections and form data immediately
    setSelectedInsurancePayerId(undefined);
    setSelectedInsurancePayer(undefined);
    setLinkPayerVal({
      payerName: "",
      payerId: "", // This will clear the "24" from your image on refresh
      claimsPhoneNumber: "",
      mailingAddress: "",
      appealsMailingAddress: "",
      payerUrl: "",
      appealViaPortal: "",
      appealURL: "",
      firstTimeBilled: "",
      dateOfDenial: "",
      inNetworkStatus: "",
      eraSetup: "",
      keywordsActive: [],
      keywordsViolate: []
    });
    fetchLinkedPayers(practice?.id);
  }

  return (
    <section>
      <Sidebar handleChangePractice={handleChangePractice} />
      <div className="linkedsection-layout">
        <div className="linkedsection-grid">
          <div className="linkedsection-table">
            <Main>
              {/* <Content className={"py-2 pr-5"} style={{ paddingRight: "18px" }}> */}
              <Content>
                <Panel
                  heading={"linked payers".toUpperCase()}
                  bodyStyle={{ padding: "0px", paddingBottom: "0px" }}
                  headStyle={{ height: "55px", marginBottom: "10px" }}
                >
                  {showTrizettoModal ?
                    <TrizettoPayerList
                      handleClose={handleCloseTrizettoModal}
                      selectedInsurancePayer={selectedInsurancePayer}
                      handleAfterRelinking={handleAfterRelinking}
                      isNewLinking={isNewLinking}
                      linkingConfirmation={showLinkingConfirmation}
                      handleLinkingConfirmation={handleLinkingConfirmation}
                      ticketModal={showTicketModal}
                      handleTicketModal={handleTicketModal}
                      encounter={{ encounterId, encounterType }}
                      refreshLinkedPayers={() => {
                        setLinkPayerVal({
                          payerName: "",
                          payerId: "",
                          claimsPhoneNumber: "",
                          mailingAddress: "",
                          appealsMailingAddress: "",
                          payerUrl: "",
                          appealViaPortal: "",
                          appealURL: "",
                          firstTimeBilled: "",
                          dateOfDenial: "",
                          inNetworkStatus: "",
                          eraSetup: "",
                          keywordsActive: [],
                          keywordsViolate: []
                        });
                        fetchLinkedPayers();
                        setIsRowChecked(false)
                      }}
                    /> :
                    <LinkedPayerTable
                      linkedPayersList={linkedPayers}
                      selectedInsurancePayerId={selectedInsurancePayerId}
                      handleSelectInsurancePayer={handleSelectInsurancePayer}
                      handleRelink={async () => {
                        await setIsNewLinking(false);
                        handleOpenTrizettoModal();
                      }}
                      selectedInsurancePayer={selectedInsurancePayer}
                      handleAfterUpdateLinkedPayer={handleAfterUpdateLinkedPayer}
                      handleAfterDeleteLinkedPayer={handleAfterDeleteLinkedPayer}
                    />
                  }
                </Panel>
              </Content>
            </Main>
          </div>
          <div className="linkedsection-form">
            {renderPanelHeader()}
          </div>
        </div>

      </div>

      <RoAlert
        show={showDeleteConfirmation}
        handleClose={() => setShowDeleteConfirmation(false)}
        handleSubmit={handleDeletePayer}
        title="you are deleting this payer"
        type="danger"
        content={
          <div className="alert-footer-text text-center mb-3">
            You are about to delete the linked payer for the practice:<br />
            <span style={{ color: '#0E0E2C' }}>{practiceData?.practiceName}</span>
          </div>
        }
      />
      <RoAlert
        show={showEditConfirmation}
        handleClose={() => setShowEditConfirmation(false)}
        handleSubmit={handleSaveClick}
        title="you are editing this payer"
        type="info"
        content={
          <div className="alert-footer-text text-center mb-3">
            You are about to edit the linked payer for the practice:<br />
            <span style={{ color: '#0E0E2C' }}>{practiceData?.practiceName}</span>
          </div>
        }
      />
      {renderLinkingModal()}
      {renderFooter()}
      {/* {renderTrizettoPayerListModal()} */}
    </section>
  );
};

export default Insurances;
